import request from '@/utils/request'

//获取插件
export function findWidgetAll(params) {
    return request({
        url: '/super/findWidgetAll',
        method: 'get',
        params,
    })
}

//获取插件
export function findAppWidgetAll(params) {
    return request({
        url: '/super/findAppWidgetAll',
        method: 'get',
        params,
    })
}

//获取插件
export function findAppWidgetList(params) {
    return request({
        url: '/super/findAppWidgetList',
        method: 'get',
        params,
    })
}
